import { useTranslation } from "react-i18next";
import { List, RadioButton, Text } from "react-native-paper";
import Box from "../Box";
import { CustomListSubheader } from "../CustomListSubheader";

export type ExportMethodOption = {
	id: string;
	title: string;
	subtitle: string;
	icon: string;
};

type Props = {
	methods: ExportMethodOption[];
	selectedMethod: string;
	onSelect: (id: string) => void;
};

export const ExportMethodSelector = ({
	methods,
	selectedMethod,
	onSelect,
}: Props) => {
	const { t } = useTranslation();
	return (
		<Box>
			<CustomListSubheader>{t("cme.chooseExportMethod")}</CustomListSubheader>
			{methods.map((method) => (
				<List.Item
					key={method.id}
					title={<Text variant="bodyMedium">{method.title}</Text>}
					description={<Text variant="bodySmall">{method.subtitle}</Text>}
					onPress={() => onSelect(method.id)}
					style={{ paddingHorizontal: 16 }}
					left={() => <List.Icon icon={method.icon} />}
					right={(p) => (
						<List.Icon
							{...p}
							icon={() => (
								<RadioButton.Android
									value={method.id}
									status={
										selectedMethod === method.id ? "checked" : "unchecked"
									}
									onPress={() => onSelect(method.id)}
								/>
							)}
						/>
					)}
				/>
			))}
		</Box>
	);
};
